import type { DataURL } from "../packages/excalidraw/types";

// IMAGES

export const convertBlobToDataURL = (blob: Blob): Promise<DataURL> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as DataURL);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const getImageDimensions = (
  blob: Blob,
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(blob);
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
      URL.revokeObjectURL(url); // Clean up the object URL
    };
    img.onerror = reject;
    img.src = url;
  });
};

export const generateUniqueId = (): string => {
  return `image-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
};

// Function to check if an element is a map background image
export const isMapBackgroundImage = (element: {
  customData: { type: string };
}) => {
  return element?.customData?.type === "mapBackgroundImage";
};

// Function to update element with new properties
export const updateElement = (
  element: { version: number },
  updates: { customData: any },
) => {
  return {
    ...element,
    ...updates,
    version: element.version + 1,
    versionNonce: Math.random(),
    updated: Date.now(),
  };
};
